export enum VriSteps {
  Zones = 'Zones',
  Configuration = 'Configuration',
  Prescription = 'Prescription',
  Save = 'Save',
}
